"use client";

/** Render a disposable fallback list within one client boundary. */
export default function ProgrammePostsFallback({
  heading,
  links,
  languageNotice,
  linkLanguage,
}: {
  heading?: string | null;
  links: readonly { href: string; title: string }[];
  languageNotice?: string;
  linkLanguage?: string;
}) {
  return (
    <section className="mb-16">
      {heading ? (
        <h2 className="mb-4 text-xl font-semibold">{heading}</h2>
      ) : null}
      {languageNotice ? (
        <p className="mb-3 text-sm text-slate-600">{languageNotice}</p>
      ) : null}
      <ul className="space-y-3">
        {links.map(({ href, title }) => (
          <li key={href}>
            <a className="underline" href={href} lang={linkLanguage}>
              {title}
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}
